module.exports = __webpack_public_path__ + "img/apple.e8747c4f.svg";